import { Component, type ReactNode } from "react";
import { DICT, DEFAULT_LANG } from "../lib/i18n-dict";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  private handleReset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      const dict = DICT[DEFAULT_LANG];
      return (
        <div className="flex min-h-[200px] flex-col items-center justify-center gap-4 p-6">
          <p className="text-muted-foreground" data-testid="error-boundary-message">
            {dict["common.loadError"] ?? "Failed to load. Please try again."}
          </p>
          <button
            type="button"
            onClick={this.handleReset}
            className="rounded-md bg-accent px-4 py-2 text-accent-foreground"
          >
            {dict["common.tryAgain"] ?? "Try again"}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
